"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grid = void 0;
var baseH = 36;
var grid = {
  rowHeight: baseH,
  columnWidth: '1fr'
};
exports.grid = grid;